import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "layout",
  "element-loading-text": "Loading",
  "element-loading-background": "rgba(0, 0, 0, 0.8)",
  "element-loading-custom-class": "layout-loading-mask"
}
const _hoisted_2 = { class: "sticky-top fixed-top w-100" }
const _hoisted_3 = { class: "size-constraint" }
const _hoisted_4 = {
  key: 1,
  class: "fill"
}
const _hoisted_5 = { class: "h-100 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_6 = { class: "font-large-5 mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_app_header)
    ]),
    _createElementVNode("main", _hoisted_3, [
      (_ctx.appIsInitialized)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_progress, {
                type: "dashboard",
                percentage: _ctx.percentage
              }, {
                default: _withCtx(({ percentage }) => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(percentage) + "%", 1),
                  _cache[0] || (_cache[0] = _createElementVNode("div", null, "Initializing", -1))
                ]),
                _: 1
              }, 8, ["percentage"])
            ])
          ]))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("footer", null, null, -1))
  ])), [
    [_directive_loading, _ctx.requestInProgress]
  ])
}